import React, { useState, useEffect } from 'react'
import { SelectBox } from '@tecuity/granite-ui'
import './CustomCorrespondenceOptions.scss'
import { useDispatch } from 'react-redux'
import * as api from 'requests'
import { SET_SETTINGS_LIST, SET_OPTIONAL_DATA } from '../../SettingsReducer'
import { useSelector, shallowEqual } from 'react-redux'
import { Spinner } from 'components/Loaders/Loaders'

const WordManagementOptions = () => {
  const dispatch = useDispatch()
  const { optionalData } = useSelector((state) => state.settings, shallowEqual)
  const [categoryOptions, setCategoryOptions] = useState([{ label: 'All', value: '0' }])
  const [category, setCategory] = useState(optionalData.category || 0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    api.GET_REPLACEMENT_WORDS_BY_CATEGORY(
      category,
      (res) => {
        dispatch({
          type: SET_SETTINGS_LIST,
          settingsList: res
            .map((item) => ({
              ...item,
              Id: item.ReplacementWordId,
              Name: item.MatchString,
            }))
            .sort((a, b) => (a.Name > b.Name ? 1 : -1)),
        })
        dispatch({
          type: SET_OPTIONAL_DATA,
          optionalData: {
            category,
          },
        })
        setLoading(false)
      },
      (err) => {
        console.error('retrieving', err)
        setLoading(false)
      }
    )
  }, [category])

  const getWordTypeOptions = () => {
    api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
      '',
      'WordReplacementCategory',
      (res) => {
        setCategoryOptions([
          { label: 'All', value: '0' },
          ...res
            .sort((a, b) => (a.Name > b.Name ? 1 : -1))
            .map((t) => ({
              value: t.Id,
              label: t.Name,
            })),
        ])
      },
      (err) => console.error(err)
    )
  }

  useEffect(() => {
    getWordTypeOptions()
  }, [])

  return (
    <div className="custom-correspondence-options">
      <SelectBox
        label="Keyword Type"
        noPlaceholder
        value={category}
        onChange={(val) => {
          setCategory(val)
        }}
        options={categoryOptions}
      />
      {loading && (
        <div className="type-loader">
          <Spinner size="small" themeColor="dark-neutral" />
        </div>
      )}
    </div>
  )
}

export default WordManagementOptions
